import React from 'react';
import { observer } from 'mobx-react';
import { ProductTypeListTemplate } from 'themes/application/product-type/pages';
import { setCurrentView } from 'core/utils';
import { ProductTypeListViewStore } from 'application/product-type/stores';

@setCurrentView((rootStore) => new ProductTypeListViewStore(rootStore), 'productTypeListViewStore')
@observer
class ProductTypeList extends React.Component {
    render() {
        return <ProductTypeListTemplate {...this.props} />
    }
}

export default ProductTypeList;